// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkin-wrapper {\n  background: #f9f9f9 !important;\n  border: 1px solid #e1e1e1 !important;\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
